import { SLIDE_GROUP_SELECTORS } from '../config/quizConfig';

// Resolves the DOM group id for a multi-select slide.
const resolveGroupName = (slideCode, explicitGroupName) => {
  if (typeof explicitGroupName === 'string' && explicitGroupName.trim()) return explicitGroupName;
  return SLIDE_GROUP_SELECTORS?.[slideCode];
};

// Handles "unselect all" action for multi-select slides
// When "None" or similar option is clicked, deselect all other options
export const handleUnselectAll = (slideCode, currentKey, slideDataSetter, explicitGroupName) => {
  const groupName = resolveGroupName(slideCode, explicitGroupName);
  if (!groupName) {
    return;
  }
  
  const labels = document.querySelectorAll(`#${groupName} label`);
  
  labels.forEach(label => {
    if (label.id !== currentKey && label.classList.contains('checked')) {
      label.classList.remove('checked');
      // ImageCheckbox uses `code={answerCode}` (not data-code). Support both.
      const answerCode = label.getAttribute('data-code') ?? label.getAttribute('code');
      slideDataSetter(slideCode, label.id, false, answerCode);
    }
  });
};

// Removes "None" selection when any other option is selected
// This is the opposite of handleUnselectAll
export const removeNoneSelection = (slideCode, slideDataSetter, explicitGroupName) => {
  const groupName = resolveGroupName(slideCode, explicitGroupName);
  if (!groupName) {
    return null;
  }
  
  const noneLabel = document.querySelector(`#${groupName} .unselect-all`);
  
  if (noneLabel && noneLabel.classList.contains('checked')) {
    noneLabel.classList.remove('checked');
    const labelId = noneLabel.id;
    const labelCode = noneLabel.getAttribute('data-code') ?? noneLabel.getAttribute('code');
    
    slideDataSetter(slideCode, labelId, false, labelCode);
    
    return { id: labelId, code: labelCode };
  }
  
  return null;
};
